/**
 * BETA — print HTML endpoints. Returns minimal printable HTML for vente,
 * and caisse Z-report. Pages auto-trigger window.print().
 */
import { httpError } from "../router.js";
import { todayYmd } from "./_utils.js";

const FOOT = "<script>setTimeout(()=>window.print(),350);</script>";
const STYLE = `<style>body{font-family:'Courier New',monospace;font-size:12px;max-width:340px;margin:0 auto;padding:16px}h1{font-size:14px;margin:0;text-align:center}h2{font-size:11px;margin:4px 0 0;text-align:center;font-weight:normal}.hr{border-bottom:1px dashed #000;margin:8px 0}table{width:100%;border-collapse:collapse;font-size:11px}td,th{padding:2px 4px;text-align:left;border:none}.right{text-align:right}.total{font-weight:bold;font-size:13px;margin-top:8px}.center{text-align:center;font-size:10px;color:#444}.badge{display:inline-block;padding:2px 6px;border:1px solid #f59e0b;border-radius:3px;font-size:9px;font-weight:bold}</style>`;

export function register(route) {
  route("GET", "/print/vente/:id", (ctx) => {
    const v = ctx.store.data.ventes.find((x) => x.id === ctx.params.id);
    if (!v) httpError(404, "Vente introuvable", "NOT_FOUND");
    const ph = ctx.store.data.pharmacie;
    const rows = (v.details || [])
      .map(
        (d) =>
          `<tr><td>${d.quantite}</td><td>${d.produit?.nom_commercial || ""}</td><td class="right">${(d.prix_unitaire || 0).toFixed(2)}</td><td class="right">${(d.montant_ligne_ttc || 0).toFixed(2)}</td></tr>`,
      )
      .join("");
    const html = `<!DOCTYPE html><html lang="fr"><head><meta charset="utf-8"><title>Reçu ${v.numero_interne}</title>${STYLE}</head><body>
<h1>${ph?.nom || "PHARMAKON"} <span class="badge">DÉMO</span></h1>
<h2>${ph?.adresse || ""} · ${ph?.telephone || ""}</h2>
<div class="hr"></div>
<div><b>Reçu N°</b> ${v.numero_interne}</div>
<div><b>Date</b> ${(v.date_vente || "").slice(0, 16).replace("T", " ")}</div>
<div><b>Type</b> ${v.type_vente} · <b>Caissier</b> ${v.caissier?.prenom || ""} ${v.caissier?.nom || ""}</div>
${v.client ? `<div><b>Client</b> ${v.client.prenom} ${v.client.nom}</div>` : ""}
<div class="hr"></div>
<table><thead><tr><th>Qté</th><th>Désignation</th><th class="right">PU</th><th class="right">Total</th></tr></thead><tbody>${rows}</tbody></table>
<div class="hr"></div>
<div class="total">TOTAL : ${(v.montant_total_ttc || 0).toFixed(2)} DA</div>
${v.type_vente === "CHIFA" ? `<div>Part CNAS : ${(v.montant_pec_chifa || 0).toFixed(2)} DA</div><div>Part patient : ${(v.montant_a_payer || 0).toFixed(2)} DA</div>` : ""}
<div>Mode : ${v.mode_paiement}</div>
<div class="hr"></div>
<p class="center">${ph?.parametres?.ticket_footer || "Merci de votre visite"}</p>
${FOOT}</body></html>`;
    return { status: 200, data: html };
  });

  route("GET", "/print/caisse/:id/zreport", (ctx) => {
    const c = ctx.store.data.caisses.find((x) => x.id === ctx.params.id);
    if (!c) httpError(404, "Caisse introuvable", "NOT_FOUND");
    const ph = ctx.store.data.pharmacie;
    const html = `<!DOCTYPE html><html lang="fr"><head><meta charset="utf-8"><title>Z-Report ${c.numero}</title>${STYLE}</head><body>
<h1>${ph?.nom || "PHARMAKON"} <span class="badge">DÉMO</span></h1>
<h2>RAPPORT Z — CLÔTURE CAISSE</h2>
<div class="hr"></div>
<div><b>Caisse</b> ${c.numero}</div>
<div><b>Caissier</b> ${c.caissier?.prenom || ""} ${c.caissier?.nom || ""}</div>
<div><b>Ouverture</b> ${(c.date_ouverture || "").replace("T", " ").slice(0, 16)}</div>
<div><b>Clôture</b> ${(c.date_cloture || "").replace("T", " ").slice(0, 16) || "—"}</div>
<div class="hr"></div>
<table><tr><td>Fonds d'ouverture</td><td class="right">${(c.fonds_ouverture || 0).toFixed(2)} DA</td></tr>
<tr><td>CA Vente Libre</td><td class="right">${(c.ca_libre || 0).toFixed(2)} DA</td></tr>
<tr><td>CA CHIFA (part patient)</td><td class="right">${(c.ca_chifa || 0).toFixed(2)} DA</td></tr>
<tr><td>Nb de ventes validées</td><td class="right">${c.nb_ventes || 0}</td></tr>
<tr><td>Fonds de clôture comptés</td><td class="right">${(c.fonds_cloture || 0).toFixed(2)} DA</td></tr></table>
<div class="hr"></div>
<div class="total">ÉCART : ${(c.ecart || 0).toFixed(2)} DA</div>
${c.notes ? `<div class="hr"></div><div>Notes : ${c.notes}</div>` : ""}
<div class="hr"></div>
<p class="center">Imprimé le ${todayYmd()}</p>
${FOOT}</body></html>`;
    return { status: 200, data: html };
  });

  route("GET", "/print/vente/:id/escpos", () => ({
    status: 200,
    data: "ESC/POS binary indisponible en mode démo — utilisez l'impression HTML.",
  }));

  route("GET", "/print/caisse/:id/zreport/escpos", () => ({
    status: 200,
    data: "ESC/POS binary indisponible en mode démo.",
  }));
}
